import map from "lodash/map";
import { CustomFieldsChangelog } from "PFApp/components/changelog/components/custom_fields_changelog/custom_fields_changelog";
import { LoadingDots } from "PFComponents/loading_dots";
import { ActivityConnectionsEvent, GenericDiff } from "PFTypes";

import { HistoryEntryTemplate } from "../../components/history_entry_template";
import { HistoryUpdatedAttributes } from "../../components/history_updated_attributes";
import { getTagRelatedEventDiff } from "./history_entry_activity_connections.utils";
import { useConnectionsMetadataToChangelog } from "./use_connections_metadata_custom_fields";
import { useHumanizedAcitivityConnectionEventDiff } from "./use_humanized_acitivity_connection_event_diff";

export const HistoryEntryActivityConnections = ({ entry }: { entry: ActivityConnectionsEvent }) => {
  const changelogData = useConnectionsMetadataToChangelog(entry.metadata);

  const isTagRelatedEvent = !!entry.metadata.activityTag;
  const diff = isTagRelatedEvent ? getTagRelatedEventDiff(entry) : entry.diff;
  const eventDiff = useHumanizedAcitivityConnectionEventDiff(diff);

  // Metadata contains before/after — render using CustomFieldsChangelog
  if (changelogData) {
    const { changelog: customFieldsChangelog, isFetching: isFetchingChangelog } = changelogData;

    return (
      <HistoryEntryTemplate entry={entry}>
        {isFetchingChangelog ? (
          <LoadingDots />
        ) : (
          <CustomFieldsChangelog customFields={customFieldsChangelog} />
        )}
      </HistoryEntryTemplate>
    );
  }

  // TODO: [SP-9670] Remove legacy history events support
  // Legacy format: render using diff-based humanized attributes
  const renderHistoryContent = () =>
    map(eventDiff, (diff, key) => (
      <HistoryUpdatedAttributes
        label={key}
        level={1}
        updatedAttributes={diff as GenericDiff}
        metadata={entry.metadata}
      />
    ));

  return <HistoryEntryTemplate entry={entry}>{renderHistoryContent()}</HistoryEntryTemplate>;
};
